// We import and export PropTypes from
// here to improve DX for VSCode
import PropTypes from 'prop-types'
export default PropTypes
